<div [formGroup]="parentForm">
  <div [formGroupName]="authControlKey">
    <div fxLayout="row wrap" fxLayoutGap="20px grid">
      <div fxFlex="100">
        <mat-card class="u-margin-bottom-15">
          <mat-card-header>
            <mat-card-title
              >{{
              "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.authentication_details"
              | translate }}</mat-card-title
            >
          </mat-card-header>
          <mat-card-content>
            <div fxFlex="100">
              <div fxLayout="row wrap" fxLayoutGap="20px grid">
                <div fxFlex="50">
                  <mat-form-field class="mat-block">
                    <input
                      id="tmSignatureMethod"
                      formControlName="tmSignatureMethod"
                      matInput
                      [placeholder]="
                    'organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.signature_method' |
                    translate"
                      readonly
                    />
                  </mat-form-field>
                </div>
                <div fxFlex="50">
                  <mat-form-field class="mat-block">
                    <input
                      id=" tmConsumerKey"
                      [required]="isRequired('tmConsumerSecret')"
                      formControlName="tmConsumerKey"
                      matInput
                      [placeholder]="'organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.consumer_key' |
                    translate"
                    />
                  </mat-form-field>
                </div>
              </div>
              <div fxLayout="row wrap" fxLayoutGap="20px grid">
                <div fxFlex="50">
                  <mat-form-field class="mat-block">
                    <input
                      id="tmConsumerSecret"
                      [required]="isRequired('tmConsumerSecret')"
                      formControlName="tmConsumerSecret"
                      matInput
                      [placeholder]="
                    'organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.consumer_secret' |
                    translate"
                    />
                  </mat-form-field>
                </div>
                <div fxFlex="50">
                  <mat-form-field class="mat-block">
                    <input
                      id="tmAccessToken"
                      [required]="isRequired('tmAccessToken')"
                      formControlName="tmAccessToken"
                      matInput
                      [placeholder]="
                    'organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.access_token' |
                    translate"
                    />
                  </mat-form-field>
                </div>
              </div>
              <div fxLayout="row wrap" fxLayoutGap="20px grid">
                <div fxFlex="50">
                  <mat-form-field class="mat-block">
                    <input
                      id="tmTokenSecret"
                      [required]="isRequired('tmTokenSecret')"
                      formControlName="tmTokenSecret"
                      matInput
                      [placeholder]="
                    'organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.token_secret' |
                    translate"
                    />
                  </mat-form-field>
                </div>
                <div fxFlex="50">
                  <mat-form-field class="mat-block">
                    <input
                      id="tmAccountId"
                      [required]="isRequired('tmAccountId')"
                      formControlName="tmAccountId"
                      matInput
                      [placeholder]="
                    'organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.account_id' |
                    translate"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div fxLayout="row wrap" fxLayoutGap="20px grid">
      <div fxFlex="100">
        <mat-card class="u-margin-bottom-15">
          <mat-card-header>
            <div fxFlex="20" class="u-text-left">
              <mat-card-title
                >{{
                "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.api_details"
                | translate }}</mat-card-title
              >
            </div>
            <div fxFlex="80" class="u-text-right">
              <button
                [disabled]="action=='view' || isTMGiftCardAddDisabled"
                mat-flat-button
                color="primary"
                (click)="openTMGiftCardSelectApiPopup();"
              >
                {{ 'organization.module_assignment_tab.reason_code_tab.add' | translate}}
              </button>
            </div>
          </mat-card-header>
          <mat-card-content
            *ngFor="let apiDetails of parentForm.get(authControlKey).get('tmGiftCardApiDetails')['controls']; let i = index"
            formArrayName="tmGiftCardApiDetails"
          >
            <div [formGroupName]="i">
              <div fxFlex="80">
                <mat-accordion>
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <!-- <input id="selectedApi" matInput formControlName="selectedApi"> -->
                        {{apiDetails.value.selectedApi}}
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div fxLayout="row wrap" fxLayoutGap="20px grid">
                      <div fxFlex="50">
                        <mat-form-field class="mat-block">
                          <input
                            [required]="isRequired('url')"
                            formControlName="url"
                            id="ebasketURL"
                            matInput
                            [placeholder]="
                    'organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.url' |
                    translate"
                          />
                        </mat-form-field>
                      </div>
                      <div fxFlex="50">
                        <mat-form-field class="mat-block">
                          <input
                            [required]="isRequired('script')"
                            formControlName="script"
                            id="ebasketScript"
                            matInput
                            [placeholder]="
                    'organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.script' |
                    translate"
                          />
                        </mat-form-field>
                      </div>
                    </div>
                    <div fxLayout="row wrap" fxLayoutGap="20px grid">
                      <div fxFlex="50">
                        <mat-form-field class="mat-block">
                          <input
                            [required]="isRequired('deploy')"
                            formControlName="deploy"
                            id="ebasketDeploy"
                            matInput
                            [placeholder]="
                    'organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.deploy' |
                    translate"
                          />
                        </mat-form-field>
                      </div>
                      <div fxFlex="50">
                        <mat-form-field class="mat-block">
                          <mat-select
                            formControlName="method"
                            id="ebasketMethod"
                            [placeholder]="
                      'organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.select_method' |
                      translate"
                          >
                            <mat-option
                              *ngFor="let methods of method_types"
                              [value]="methods.value"
                            >
                              {{methods.name}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
              <div fxFlex="20" class="u-text-right">
                <button
                  [disabled]="action=='view'"
                  mat-flat-button
                  color="primary"
                  (click)="deleteTmGiftCardApiDetailContainer(i);"
                >
                  {{ 'organization.create.section_4.customer_hub_section_1.delete' | translate}}
                </button>
              </div>
            </div>
          </mat-card-content>

          <div
            *ngFor="let apiDetails of parentForm.get(authControlKey).get('tmGiftCardApiDetails')['controls']; let i = index"
          >
            <mat-error
              *ngIf="(action !== 'view') &&(!apiDetails.value.url || !apiDetails.value.script || !apiDetails.value.deploy || !apiDetails.value.method)"
            >
              {{ "organization.module_assignment_tab.reason_code_tab.tmSettingsApi_details_required"
              | translate }}
            </mat-error>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>
